import { DataGrid } from '@twilio-paste/core/data-grid';

import { useApp } from '../../../modules/Apps';
import { CreateScopesDrawer, EditScopesDrawer, ReadOnlyScopeDrawer } from '../ScopesForm';

import { ScopesTableContent } from './ScopesTableContent';
import { useScopesTableContext } from './ScopesTableContext';
import { ScopesTableHeader } from './ScopesTableHeader';

interface ScopesTableProps {
  appId: string;
}

export function ScopesTable({ appId }: ScopesTableProps) {
  const { data: app, isLoading, isError } = useApp(appId);
  const { createScopeDrawerState, editScopeDrawerState, viewScopeDrawerState, editingScope } =
    useScopesTableContext();

  return (
    <>
      <DataGrid aria-label="Scopes table">
        <ScopesTableHeader />
        <ScopesTableContent app={app} isLoading={isLoading} isError={isError} />
      </DataGrid>
      <CreateScopesDrawer state={createScopeDrawerState} appId={appId} />
      {editingScope && <EditScopesDrawer scope={editingScope} state={editScopeDrawerState} />}
      {editingScope && <ReadOnlyScopeDrawer scope={editingScope} state={viewScopeDrawerState} />}
    </>
  );
}
